import pages from '../pages.js';

const setScreenSeasonalityFilterAndRedirect = ()=>{
    window.localStorage.setItem("screen-seasonality-sortCol","stock_score_normalized")
    window.localStorage.setItem("screen-sseasonality-sortDir","desc")

    window.localStorage.setItem("screen-seasonality-change","3,20")
    window.localStorage.setItem("screen-seasonality-weeks","13")
    window.localStorage.setItem("screen-seasonality-winning","65")

    window.localStorage.setItem("screen-seasonality-signal","2")
    window.localStorage.setItem("screen-seasonality-optionable","2")
    window.localStorage.setItem("screen-seasonality-price","10,300")

    window.localStorage.setItem("screen-seasonality-sma50","2")
    window.localStorage.setItem("screen-seasonality-avg_daily_volume","500000,1500000")

    window.localStorage.setItem("screen-seasonality-av365","2")
    window.localStorage.setItem("screen-seasonality-years","7")
    window.localStorage.setItem("screen-seasonality-sma20sma50","14")

    window.location.href = "/seasonality/screen";
}

export default function() {
    $("#registrationModal").on('registered', function() {
        setScreenSeasonalityFilterAndRedirect();
    });

    console.log("TOP SEASONAL STOCKS")

    $(".set-filters-and-redirect").on("click",setScreenSeasonalityFilterAndRedirect)
}